import React from "react";
import "../Styles/hero.css";

const Hero = () => {
  return (
    <div className="relative h-[100vh] w-full overflow-hidden">
      <img
        className="absolute top-0 left-0 w-full h-full object-cover gradient"
        src="https://res.cloudinary.com/duchitv8b/image/upload/f_auto,q_auto/hktntzt2v7qyz2wcd2qv"
        alt="hero"
      />
      <div className="absolute inset-0 bg-black bg-opacity-50 flex flex-col items-center justify-center text-center px-4 sm:px-6 sm:space-y-6">
        <h1
          className="text-white text-4xl sm:text-5xl md:text-5xl lg:text-6xl xl:text-8xl font-bold tracking-wide drop-shadow-lg"
          data-aos="fade-down"
          data-aos-duration="1000"
        >
          Studio Of African <br /> Wildlife Art
        </h1>
      </div>

      <div class="gradient-overlay"></div>
    </div>
  );
};

export default Hero;
